module.exports = __webpack_public_path__ + "static/media/nima_walking_3.eb5c7695.gif";